import React from 'react';
import { useContent } from '../../hooks/useContent';
import { useTheme } from '../../hooks/useTheme';
import { ChevronRightIcon } from '../ui/ChevronRightIcon';

interface HeroSectionProps {
  onSimulateClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onSimulateClick }) => {
  const { getHeroContent } = useContent();
  const { getBackgroundClass, getTextClass } = useTheme();
  
  const heroContent = getHeroContent();
  
  if (!heroContent) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-teal-400" />
      </div>
    );
  }
  
  return (
    <section className={`min-h-screen flex items-center justify-center ${getBackgroundClass('primary')}`}>
      <div className="container mx-auto px-4 sm:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-white mb-6 leading-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-sky-500">Soluções Digitais</span> Sem Burocracia
          </h1>
          
          <p className={`text-xl md:text-2xl mb-8 ${getTextClass('secondary')} max-w-3xl mx-auto leading-relaxed`}>
            {heroContent.subtitle}
          </p>
          
          <div className="overflow-hidden">
            <button
              onClick={onSimulateClick}
              className="px-8 py-4 text-lg bg-gradient-to-r from-teal-400 to-sky-500 text-white font-bold rounded-full shadow-lg transition-transform duration-300 transform hover:scale-105"
              style={{ transformOrigin: 'center center' }}
            >
            Solicitar Orçamento Personalizado <ChevronRightIcon className="inline-block w-5 h-5 ml-2 -mr-1" />
             </button>
           </div>
          
          {/* Features section removed as it doesn't exist in HeroSection interface */}
        </div>
      </div>
    </section>
  );
};

export { HeroSection };